import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import { SelectTeams } from './SelectTeams/SelectTeams';
import { BaseField } from '../types';

export interface SelectTeamsFieldDef extends BaseField {
  type: 'select-teams';
}

const SelectTeamsFieldForm = ({ field }: { field: SelectTeamsFieldDef }) => {
  const { control, formState: { errors } } = useFormContext();
  const currentError = _.get(errors, field.key);

  return (
    <Controller
      name={field.key}
      control={control}
      render={({ field: f }) => (
        <>
          <SelectTeams label={field.label ?? ''} value={f.value ?? []} onChange={f.onChange} />
          {currentError && (
            <p className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>
              {(currentError as any).message}
            </p>
          )}
        </>
      )}
    />
  );
};

export default SelectTeamsFieldForm;
